// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Qj-z","tupacHeader":"Rj-z","tupacHeader2":"Sj-z","tupacMenu":"Tj-z","tupacMenu2":"Uj-z","tupacMain":"Vj-z","tupacMain2":"Wj-z"};